module.exports = __webpack_public_path__ + "static/img/unit_bg_all1.5234ac5c.jpg";